import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import {
  Card,
  CardContent,
  Table,
  TableCell,
  TableRow,
  Container,
  TableHead,
  TableContainer,
  Grid,
  createMuiTheme,
  TextField,
  MenuItem,
  Button,
  Backdrop,
  CircularProgress,
  BottomNavigationAction,
  Dialog, DialogActions, DialogContent, DialogTitle, TableBody, FormControlLabel, IconButton,Snackbar,TablePagination
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SearchBar from 'material-ui-search-bar';
import { sc } from 'src/utils/Common';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { getAnnouncementType, getAnnouncements, setAnnouncements, getAnnouncementDetails } from '../../../store/slices/announcementSlice';
import moment from 'moment';
import Checkbox from '@material-ui/core/Checkbox';
import EditIcon from '@material-ui/icons/Edit';
import { confirmAlert } from 'react-confirm-alert';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';

const DefaultAnnouncementValue = {
  AnnouncementId:0,
  Dsc: '',
  Type: 1,
  StartDate: moment(),
  EndDate: moment(),
  Active: 1,
  CreateDate: '',
  CreateEmployeeId: '',
  Header: '',
};

const useStyles = makeStyles((theme) => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  cardscontent: {
    minHeight: 530,
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  container: {
    maxHeight: 630,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale,
};

function Announcement(readonly) {
  const SessionUser = getUser();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation('Catalog');
  const locale = localStorage.getItem('i18nextLng');

  const AnnouncementType = useSelector((state) => state.announcement.AnnouncementType);
  const AnnouncementData = useSelector(state => state.announcement.AnnouncementData);
  const Announcements = useSelector(state => state.announcement.Announcements);
  const LoadingAnnouncement = useSelector((state) => state.announcement.loading);

  //For Announcements list(AnnouncementId, description vb.)
  const [announcementsList, setAnnouncementsList] = useState([]);

  const [formData, setFormdata] = useState(DefaultAnnouncementValue);
  //Announcement Popup
  const [announcementPopUp, setAnnouncementPopUp] = useState(false);

  //Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  //SearchBar
  const [searched, setSearched] = useState('');
  const [initialRows, setinitialRows] = useState('');

  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  
  useEffect(() => {
    dispatch(getAnnouncementType());
    dispatch(getAnnouncements())
  }, [dispatch]);

  useEffect(() => {
    setAnnouncementsList(Announcements);
    setinitialRows(Announcements);
  }, [Announcements]);

  useEffect(() => {
    if (!AnnouncementData) {
      return
    }
    if (!AnnouncementData[0]) {
      return
    }
    setFormdata(AnnouncementData[0]);
  }, [AnnouncementData]);

  const requestSearch = (searchedVal) => {
    const filteredRows = initialRows.filter((item) => sc(
      item.Header + item.Dsc + item.StartDate + item.EndDate ,
      searchedVal
    ));
    //setinitialRows(searchedVal)
    setAnnouncementsList(filteredRows);
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleStartDateChange = value => {
    var DateValue = moment(value).format('YYYY-MM-DD');
    setFormdata({ ...formData, StartDate: DateValue });
  }
  const handleEndDateChange = value => {
    var DateValue = moment(value).format('YYYY-MM-DD');
    setFormdata({ ...formData, EndDate: DateValue });
  }


  const editAnnouncement = (announcemenId) => {
    setFormdata(DefaultAnnouncementValue);
    setAnnouncementPopUp(true);
    dispatch(getAnnouncementDetails(announcemenId));
  }
  const confirmAnnouncementDetails = () => {

    setAnnouncementPopUp(false);
    confirmAlert({
      message: t('lblConfirm'),
      buttons: [
        {
          label: t('lblYes'),
          onClick: () => {
            updateRetailer()
          }

        },
        {
          label: t('lblNo'),
          onClick: () => {
            setAnnouncementPopUp(true);
            return;
          }
        }
      ]
    });
  }
  const updateRetailer = () => {
    dispatch(setAnnouncements(JSON.parse(JSON.stringify({ ...formData, CreateEmployeeId: SessionUser.TechnicianId })))).then(response => {
      dispatch(getAnnouncements()).then(response => {
        setAnnouncementsList(response.payload);
      })
      if (response.ErrorCode && response.ErrorCode === '1000') {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t(response.ErrorDescription)
        });
        setUyariTip('error');
        setUyari(true);
      } else {
        setFormdata(response);
        setresponseMessage({
          ErrorCode: response.ErrorCode,
          ErrorDescription: t('lblSuccessOperation')
        });
        setUyariTip('success');
        setUyari(true);
      }
    })
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Page title="">
      <Backdrop className={classes.backdrop} open={ LoadingAnnouncement }>
        <CircularProgress color="inherit" />
      </Backdrop>
        <Container maxWidth="xl" spacing={1} className={classes.root}>
        <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={1} lg={1}>
                  <BottomNavigationAction
                    showLabel
                    label={t('lblNewAnnouncement')}
                    onClick={() => {
                      setFormdata({ ...DefaultAnnouncementValue })
                      setAnnouncementPopUp(true);
                    }}
                    icon={<AddAlertIcon />}
                  />

                </Grid>
                <Grid item xs={12} sm={1} lg={6}>
                </Grid>
                <Grid item xs={12} sm={5} lg={5}>
                  <SearchBar
                    value={searched}
                    placeholder={t('lblSearch')}
                    onChange={(searchVal) => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
              </Grid>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t('lblHeader')}</TableCell>
                      <TableCell align="left">{t('lblType')}</TableCell>
                      <TableCell align="left">{t('lblDescription')}</TableCell>
                      <TableCell align="left">{t('lblStartDate')}</TableCell>
                      <TableCell align="left">{t('lblEndDate')}</TableCell>
                      <TableCell align="left">{t('lblActive')}</TableCell>
                      <TableCell align="left">{t('lblEdit')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {(rowsPerPage > 0
                      ? announcementsList.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : announcementsList
                    ).map(item => (
                      <TableRow key={item.AnnouncementId}>
                        <TableCell align="left">{item.Header}</TableCell>
                        <TableCell align="left">{AnnouncementType.filter(i => i.Id === item.Type)[0]?.Dsc}</TableCell>
                        <TableCell align="left">{item.Dsc}</TableCell>
                        <TableCell align="left">{moment(item.StartDate).format('DD.MM.YYYY')}</TableCell>
                        <TableCell align="left">{moment(item.EndDate).format('DD.MM.YYYY')}</TableCell>
                        <TableCell align="left">
                          <FormControlLabel
                            control={(
                              <Checkbox
                                disabled
                                name="checkedB"
                                color="primary"
                                checked={item.Active === 1}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <IconButton aria-label="update"
                            onClick={() => editAnnouncement(item.AnnouncementId)}
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[15, 25, 35]}
                component="div"
                count={announcementsList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
        </Container>
        <Dialog
          open={announcementPopUp}
          fullWidth={true}
          onClose={() => setAnnouncementPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ textAlign: 'center' }}>{t('lblAnnouncementDetail')}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <Card className={classes.cards}>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1} >
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="Header"
                          required
                          autoComplete="no"
                          fullWidth
                          value={formData.Header ? formData.Header : ''}
                          onChange={event =>
                            setFormdata({
                              ...formData,
                              Header: event.target.value
                            })
                          }
                          label={t('lblHeader')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          select
                          autoComplete="no"
                          label={t('lblType')}
                          id="Type"
                          variant="outlined"
                          value={AnnouncementType[0] ? formData.Type ? formData.Type : AnnouncementType[0].Id : ''}
                          onChange={event =>
                            setFormdata({
                              ...formData,
                              Type: event.target.value
                            })
                          }
                        >
                          {AnnouncementType ? AnnouncementType?.map(p => {
                            return (
                              <MenuItem key={p.Id} value={p.Id}>
                                {p.Dsc}
                              </MenuItem>
                            );
                          }) : ''}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          select
                          autoComplete="no"
                          id="Active"
                          label={t('lblActive')}
                          variant="outlined"
                          value={formData ? formData.Active : ''}
                          onChange={(event) => setFormdata({ ...formData, Active: event.target.value })}
                        >
                          <MenuItem key={0} value={0}>
                            {t('lblPassive')}
                          </MenuItem>

                          <MenuItem key={1} value={1}>
                            {t('lblActive')}
                          </MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <ThemeProvider theme={materialTheme}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                            <KeyboardDatePicker
                              margin="normal"
                              color="primary"
                              inputVariant="outlined"
                              id="StartDate"
                              size="small"
                              label={t('lblStartDate')}
                              invalidDateMessage={t('hatali_tarih')}
                              format="dd.MM.yyyy"
                              fullWidth
                              variant="outlined"
                              disable={readonly}
                              value={formData.StartDate ? formData.StartDate : moment()}
                              onChange={(e) => handleStartDateChange(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <ThemeProvider theme={materialTheme}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                            <KeyboardDatePicker
                              margin="normal"
                              color="primary"
                              inputVariant="outlined"
                              id="EndDate"
                              size="small"
                              label={t('lblEndDate')}
                              invalidDateMessage={t('hatali_tarih')}
                              format="dd.MM.yyyy"
                              fullWidth
                              variant="outlined"
                              disable={readonly}
                              value={formData.EndDate ? formData.EndDate : moment()}
                              onChange={(e) => handleEndDateChange(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="Description"
                          autoComplete="no"
                          multiline
                          rows={15}
                          fullWidth
                          value={formData.Dsc ? formData.Dsc : ''}
                          onChange={event =>
                            setFormdata({
                              ...formData,
                              Dsc: event.target.value
                            })
                          }
                          label={t('lblDescription')}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => confirmAnnouncementDetails()}
              endIcon={<SaveIcon />}>
              {t('lblSave')}
            </Button>
            <Button
              color="primary"
              aria-label="close"
              onClick={() => setAnnouncementPopUp(false)}
              component="span"
              variant="contained"
              endIcon={<CloseIcon />}
            > {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>
      </Page>
    </>
  );
}
export default Announcement;
